import React, { Component } from "react"
import { connect } from 'react-redux'
import {
    saveTransactionAction
} from '../../redux/actions/MainAction'
import moment from 'moment'
import {msg} from '../../components/Notifications/MsgBox';
import POHistory from '../../components/POHistory';
import { data_t_HEADER } from "../../configs/datas";
import { Storage, MessageText } from '../../configs'
import Button from "@material-ui/core/Button";
import AccessTimeIcon from '@material-ui/icons/AccessTime';

class PODetail extends Component {

    constructor() {
        super()

        this.state = {
            // ...props,
            po_contract_no: "",
            openPOHistory:false
        }

        this.handlePoChange = this.handlePoChange.bind(this)
        this.handlerSearchPO=this.handlerSearchPO.bind(this)
        this.getDocName = this.getDocName.bind(this)
    }

    getStatus(status_code) {
        const result = this.props.status_data.filter((data) => {
            return data.code == status_code
        })
        return result[0] ? result[0].description : ""
    }

    handlePoChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    handlerSearchPO(){
        if(this.props.onSearchPO){
            if(!this.state.po_contract_no){
                msg.error("กรุณากรอกข้อมูล Purchase / Contract Number");
                return;
            }
            this.props.onSearchPO(this.state.po_contract_no)
        }     
    }

    getDocName(docName) {
        let docNameNew = docName
        if (docName && docName.indexOf("#!#") >= 0) {
            docNameNew = docName.split("#!#").map((item, index) => {
                if (index == docName.split("#!#").length) {
                    return <span key={index}>{item}</span>
                } else {
                    return <React.Fragment key={index}><span>{item}</span><br /></React.Fragment>
                }

            });
        }

        return docNameNew
    }

    handleOnClosePOHistory(){
        this.setState({
            openPOHistory: false
        })
    }

    handleOnOpenPOHistory(){
        this.setState({
            openPOHistory: true
        })
    }

    render() {
        //console.log("PODetail.render()")
        let{
            t_PO_DETAIL,
            t_PO_COMMITTEE,
            t_HEADER,
            transaction_no,
        }=this.props
        const user = Storage.getUser()
        const approver = t_PO_COMMITTEE.filter(committee => committee.code === user.userName && committee.accept_status === null) 
        console.log("po_detail =>> t_PO_DETAIL =>>  ",t_PO_DETAIL)
        console.log("po_detail =>> t_HEADER =>>  ",t_HEADER)
        return (
            <div className="collapse rrs-container-wrap" id="rrsTab1" aria-labelledby="rrsPoDetail" data-parent="#invoiceRecordingSystem">
                <div className="rrs-container">
                    {/* Start content tab 1 */}

                    <div className="rrs-detail2">

                        {/* {transaction_no == null && (
                            <div className="rrs-form-group-search">
                                <label htmlFor="search-purchase-num" className="rrs-form-group-search-label">Purchase / Contract Number</label>
                                <div className="row justify-content-center mx-0">
                                    <div className="col-md-5">
                                        <input
                                            type="text"
                                            name="po_contract_no"
                                            id="po_contract_no"
                                            className={"form-control form-control-search" + (this.state.po_contract_no.length === 10 ? " search-icon" : "")}
                                            placeholder="กรุณากรอกข้อมูล Purchase / Contract Number"
                                            value={this.state.po_contract_no}
                                            onChange={this.handlePoChange}
                                        />
                                        <button className="rrs-btn-icon" onClick={() =>{this.handlerSearchPO()}}>
                                            <i className="icon bt-search" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )} */}

                        {t_PO_DETAIL.po_contract_no && (
                            <div className="rrs-result">
                                {/* Status */}
                                <div className="row rrs-status-wrap">
                                    <div className="col-3 rrs-panelstatus rrs-detail-item">
                                        <div className="sp-rrs-detail-label">Status :
                                        <span className="sp-rrs-detail-data ml-2" id="po-status">{this.getStatus(t_PO_DETAIL.status)}</span></div>
                                    </div>
                                    <div className="col-5 rrs-panelstatus rrs-detail-item">
                                        { (t_PO_DETAIL.status === 'REJT' || t_PO_DETAIL.status === 'DECL')  && (
                                            <div className="sp-rrs-detail-label">สาเหตุส่งกลับแก้ไข : 
                                            <span className="sp-rrs-detail-data-reject ml-2" id="po-reject">{t_PO_DETAIL.reject_Option_Desc + ' ' + t_PO_DETAIL.reject_Result}</span></div>
                                        )}
                                    </div>
                                    <div className="col-4 " style={{textAlign:'end'}}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            startIcon={<AccessTimeIcon />}
                                            onClick={()=>{this.handleOnOpenPOHistory()}}
                                        >
                                            History
                                        </Button>
                                    </div>
                                    {/* {((t_PO_DETAIL.status === 'REJT'|| t_PO_DETAIL.status === 'VERI') && t_PO_DETAIL.reject_Result ) ?
                                        <div className="col-9" style={{ paddingLeft: '58px' }}>
                                            <div className="sp-rrs-detail-label" style={{ fontSize: '1rem', fontWeight: 'bold' }} >สาเหตุส่งกลับแก้ไข</div>
                                            <div className="rrs-detail-data" id="rejectremark" style={{ marginTop: '10px', marginBottom: '20px' }}><span>*{t_PO_DETAIL.reject_Result}</span></div>
                                        </div> : null} */}
                                </div>
                                {/* PO No. box */}
                                <div className="row rrs-wrap">
                                    <div className="col-12 col-lg-3 rrs-panel">
                                        <div className="rrs-detail1">
                                            <div className="row rrs-detail-row">
                                                <div className="col-12 rrs-detail-item rrs-po-num">
                                                    <div className="rrs-detail-label rrs-detail-label-large">PO / Contract No.</div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.po_contract_no}</div>
                                                </div>
                                                {/* <div className="col-12 rrs-detail-item rrs-mom">
                                                    <div className="rrs-detail-label rrs-detail-label-large">Ref. PO</div>
                                                    <div className="rrs-detail-data">{t_HEADER.ref_po}</div>
                                                </div>  */}
                                                <div className="col-12 rrs-detail-item rrs-mom">
                                                    <div className="rrs-detail-label rrs-detail-label-large">MOM Doc No.</div>
                                                    <div className="rrs-detail-data">{t_HEADER?t_HEADER.mom_no:""}</div>
                                                </div>
                                                { t_HEADER.doc_no && (
                                                <div className="col-12 rrs-detail-item rrs-mom">
                                                    <div className="rrs-detail-label rrs-detail-label-large">RRS Doc No.</div>
                                                    <div className="rrs-detail-data">{t_HEADER.doc_no}</div>
                                                </div>  
                                                )}
                                                <div className="col-12 rrs-detail-item rrs-vendor">
                                                    <div className="rrs-detail-label mr-1">Vendor Code</div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.vendor_code}</div>
                                                </div>
                                                <div className="col-12 rrs-detail-item rrs-vendor">
                                                    <div className="rrs-detail-label mr-1">Vendor Name</div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.vendor_name}</div>
                                                </div>
                                                <div className="col-12 rrs-detail-item rrs-createby pr-0">
                                                    <div className="rrs-detail-label">
                                                        <i className="icon icon-user" />พนักงานจัดหาผู้รับผิดชอบ PO/Contract</div>
                                                    <div className="rrs-detail-data">

                                                        <p className="rrs-detail-data-p">
                                                            {/* {t_PO_DETAIL.create_po_contract_emp_id + " " + t_PO_DETAIL.create_po_contract_emp_name} */}
                                                            {t_PO_DETAIL.create_po_contract_emp_name}
                                                        </p>
                                                        <p className="rrs-detail-data-p">{"หน่วยงาน : " + t_PO_DETAIL.create_po_contract_department_name}</p>
                                                    </div>
                                                </div>
                                                <div className="col-12 rrs-detail-item rrs-docdate">
                                                    <div className="row no-gutters">
                                                        <div className="rrs-detail-label"><i className="icon icon-time" />Document Date</div>
                                                        <div className="rrs-detail-data">
                                                            <span className="hilight">{t_PO_DETAIL.po_date ? moment(t_PO_DETAIL.po_date).format('DD/MM/YYYY') : ""}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-9 rrs-panel21">
                                        <div className="rrs-detail22">
                                            <div className="row rrs-detail-row">
                                                <div className="col-12 rrs-detail-item rrs-detail-item-docname">
                                                    <div className="rrs-detail-label">ชื่อเอกสาร</div>
                                                    <div className="rrs-detail-data">{this.getDocName(t_PO_DETAIL.document_name)}</div>
                                                </div>
                                            </div>
                                            <div className="row rrs-detail-row">
                                                <div className="col-12 col-md-4 col-lg-3 rrs-detail-item">
                                                    <div className="rrs-detail-label">ระยะเวลารับประกัน</div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.des_warranty}</div>
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3 rrs-detail-item">
                                                    <div className="rrs-detail-label">วงเงินค้ำประกัน </div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.des_money_warranty}</div>
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3 rrs-detail-item">
                                                    <div className="rrs-detail-label">ชื่อผู้อนุมัติ</div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.des_approve_name}</div>
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3 rrs-detail-item">
                                                    <div className="rrs-detail-label">ตำแหน่งผู้อนุมัติ</div>
                                                    {/* <div className="rrs-detail-data">{t_PO_DETAIL.des_approve_position_name?t_PO_DETAIL.des_approve_position_name.replaceAll("#!#"," "):""}</div> */}
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.des_approve_position_name?t_PO_DETAIL.des_approve_position_name.split("#!#").join(" "):""}</div>
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3 rrs-detail-item">
                                                    <div className="rrs-detail-label">วิธีการจัดหา</div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.des_search_method}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Table */}
                                <div className="sp-page-wrapper">
                                    <div className="sp-table-container">
                                        <h3 className="rrs-sub-header">คณะกรรมการตรวจรับ</h3>
                                        <div className="row no-gutters sp-table-content">
                                            <table className="sp-table table rrs-table rrs-table-purple">
                                                <thead>
                                                    <tr className="sp-table-header">
                                                        {/* <th className="th-no"><div className="th-text">ลำดับ</div></th> */}
                                                        <th className="th-docnum"><div className="th-text">ชื่อ - นามสกุล</div></th>
                                                        <th className="th-projectname"><div className="th-text">หน่วยงาน</div></th>
                                                        <th className="th-budget"><div className="th-text">โทรศัพท์</div></th>
                                                        <th className="th-method"><div className="th-text">Email</div></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {t_PO_COMMITTEE && (t_PO_COMMITTEE).map((item, index) => (
                                                        <tr key={index + 1}>
                                                            {/* <td className="td-num">{item.sequence}</td> */}
                                                            <td className="nowrap-whitespace">{item.fullname}</td>
                                                            <td className="nowrap-whitespace">{item.department}</td>
                                                            <td className="nowrap-whitespace">{item.telephone}</td>
                                                            <td><a href={"mailto:" + item.email + ";"}>{item.email}</a></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="rrs-detail" style={{ visibility: this.props.viewMode ? (approver.length <= 0 ? "hidden" : "visible" ) : "visible" }}>
                                    <div className="row sp-table-content-footer">
                                        <div className="col-12 sp-header-button-panel2 justify-content-center">
                                            <a href="#" className="sp-btn-icon btn-ok" data-toggle="collapse" data-target="#rrsTab2" aria-expanded="false" aria-controls="rrsTab2"
                                              >
                                                <i className="icon btn-order-check-green" />
                                                <span className="sp-btn-icon-label3">{MessageText.APP.MSG_BOX_BUTTON_TEXT_OK}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {/* End content tab 1 */}
                </div>
                <POHistory open={this.state.openPOHistory} transactionNo={transaction_no} onClose={()=>{this.handleOnClosePOHistory()}}></POHistory>
            </div>

        )
    }
}

const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        viewMode : MainRedux.viewMode,
        transaction_no: MainRedux.transaction_no,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL,
        t_PO_COMMITTEE: MainRedux.t_PO_COMMITTEE,
        t_HEADER: MainRedux.t_HEADER,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PODetail)